"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
var vue_1 = require("vue");
var _withScopeId = function (n) { return (vue_1.pushScopeId("data-v-074777e2"), n = n(), vue_1.popScopeId(), n); };
var _hoisted_1 = {
    key: 0,
    class: "transfer-h5-header"
};
var _hoisted_2 = { class: "title" };
var _hoisted_3 = { class: "main" };
var _hoisted_4 = { class: "left" };
var _hoisted_5 = { key: 0 };
var _hoisted_6 = { class: "list" };
var _hoisted_7 = { class: "all" };
var _hoisted_8 = ["onClick"];
var _hoisted_9 = {
    key: 0,
    class: "list-item-flex"
};
var _hoisted_10 = ["src"];
var _hoisted_11 = { class: "name" };
var _hoisted_12 = { key: 0 };
var _hoisted_13 = { class: "right" };
var _hoisted_14 = { key: 0 };
var _hoisted_15 = { class: "list" };
var _hoisted_16 = { key: 0 };
var _hoisted_17 = ["src"];
var _hoisted_18 = { key: 0 };
var _hoisted_19 = ["onClick"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (vue_1.openBlock(), vue_1.createElementBlock("div", {
        class: vue_1.normalizeClass(["transfer", [_ctx.isH5 ? 'transfer-h5' : '']])
    }, [
        (_ctx.isH5)
            ? (vue_1.openBlock(), vue_1.createElementBlock("header", _hoisted_1, [
                vue_1.createElementVNode("i", {
                    class: "icon icon-back",
                    onClick: _cache[0] || (_cache[0] =
                        //@ts-ignore
                        function () {
                            var args = [];
                            for (var _i = 0; _i < arguments.length; _i++) {
                                args[_i] = arguments[_i];
                            }
                            return (_ctx.cancel && _ctx.cancel.apply(_ctx, args));
                        })
                }),
                vue_1.createElementVNode("span", _hoisted_2, vue_1.toDisplayString(_ctx.title), 1)
            ]))
            : vue_1.createCommentVNode("", true),
        vue_1.createElementVNode("main", _hoisted_3, [
            vue_1.createElementVNode("div", _hoisted_4, [
                (_ctx.isSearch)
                    ? (vue_1.openBlock(), vue_1.createElementBlock("header", _hoisted_5, [
                        vue_1.createElementVNode("input", {
                            type: "text",
                            onKeyup: _cache[1] || (_cache[1] = vue_1.withKeys(
                            //@ts-ignore
                            function () {
                                var args = [];
                                for (var _i = 0; _i < arguments.length; _i++) {
                                    args[_i] = arguments[_i];
                                }
                                return (_ctx.handleInput && _ctx.handleInput.apply(_ctx, args));
                            }, ["enter"])),
                            placeholder: "请输入昵称",
                            enterkeyhint: "search"
                        }, null, 32)
                    ]))
                    : vue_1.createCommentVNode("", true),
                vue_1.createElementVNode("main", null, [
                    vue_1.createElementVNode("ul", _hoisted_6, [
                        (_ctx.optional.length > 1 && !_ctx.isRadio)
                            ? (vue_1.openBlock(), vue_1.createElementBlock("li", {
                                key: 0,
                                class: "list-item",
                                onClick: _cache[2] || (_cache[2] =
                                    //@ts-ignore
                                    function () {
                                        var args = [];
                                        for (var _i = 0; _i < arguments.length; _i++) {
                                            args[_i] = arguments[_i];
                                        }
                                        return (_ctx.selectedAll && _ctx.selectedAll.apply(_ctx, args));
                                    })
                            }, [
                                vue_1.createElementVNode("i", {
                                    class: vue_1.normalizeClass(["icon", [
                                            _ctx.selectedList.length === _ctx.optional.length ? 'icon-selected' : 'icon-unselected',
                                        ]])
                                }, null, 2),
                                vue_1.createElementVNode("span", _hoisted_7, vue_1.toDisplayString(_ctx.$t("component.全选")), 1)
                            ]))
                            : vue_1.createCommentVNode("", true),
                        (vue_1.openBlock(true), vue_1.createElementBlock(vue_1.Fragment, null, vue_1.renderList(_ctx.list, function (item, index) {
                            var _a;
                            return (vue_1.openBlock(), vue_1.createElementBlock("li", {
                                class: "list-item",
                                key: index,
                                onClick: function ($event) { return (_ctx.selected(item)); }
                            }, [
                                (!item.conversationID || ((_a = item.conversationID) === null || _a === void 0 ? void 0 : _a.indexOf('server_')) === -1)
                                    ? (vue_1.openBlock(), vue_1.createElementBlock("div", _hoisted_9, [
                                        vue_1.createElementVNode("i", {
                                            class: vue_1.normalizeClass(["icon", [
                                                    (item === null || item === void 0 ? void 0 : item.isDisabled) && 'disabled',
                                                    _ctx.selectedList.indexOf(item) > -1 ? 'icon-selected' : 'icon-unselected',
                                                ]])
                                        }, null, 2),
                                        (!_ctx.isCustomItem)
                                            ? (vue_1.openBlock(), vue_1.createElementBlock(vue_1.Fragment, { key: 0 }, [
                                                vue_1.createElementVNode("img", {
                                                    class: "avatar",
                                                    src: (item === null || item === void 0 ? void 0 : item.avatar) || 'https://image.iguopin.com/data/app/im-logo.png',
                                                    onerror: "this.src='https://image.iguopin.com/data/app/im-logo.png'"
                                                }, null, 8, _hoisted_10),
                                                vue_1.createElementVNode("span", _hoisted_11, vue_1.toDisplayString((item === null || item === void 0 ? void 0 : item.nick) || (item === null || item === void 0 ? void 0 : item.userID)), 1),
                                                (item === null || item === void 0 ? void 0 : item.isDisabled)
                                                    ? (vue_1.openBlock(), vue_1.createElementBlock("span", _hoisted_12, "（" + vue_1.toDisplayString(_ctx.$t("component.已在群聊中")) + "）", 1))
                                                    : vue_1.createCommentVNode("", true)
                                            ], 64))
                                            : vue_1.renderSlot(_ctx.$slots, "left", {
                                                key: 1,
                                                data: item
                                            }, undefined, true)
                                    ]))
                                    : vue_1.createCommentVNode("", true)
                            ], 8, _hoisted_8));
                        }), 128))
                    ])
                ])
            ]),
            vue_1.createElementVNode("div", _hoisted_13, [
                (!_ctx.isH5)
                    ? (vue_1.openBlock(), vue_1.createElementBlock("header", _hoisted_14, vue_1.toDisplayString(_ctx.title), 1))
                    : vue_1.createCommentVNode("", true),
                vue_1.withDirectives(vue_1.createElementVNode("ul", _hoisted_15, [
                    (_ctx.selectedList.length > 0 && !_ctx.isH5)
                        ? (vue_1.openBlock(), vue_1.createElementBlock("p", _hoisted_16, vue_1.toDisplayString(_ctx.$t("component.已选中")) + vue_1.toDisplayString(_ctx.selectedList.length) + vue_1.toDisplayString(_ctx.$t("component.人")), 1))
                        : vue_1.createCommentVNode("", true),
                    (vue_1.openBlock(true), vue_1.createElementBlock(vue_1.Fragment, null, vue_1.renderList(_ctx.selectedList, function (item, index) {
                        return (vue_1.openBlock(), vue_1.createElementBlock("li", {
                            class: "list-item space-between",
                            key: index
                        }, [
                            vue_1.createElementVNode("aside", null, [
                                (!_ctx.isCustomItem)
                                    ? (vue_1.openBlock(), vue_1.createElementBlock(vue_1.Fragment, { key: 0 }, [
                                        vue_1.createElementVNode("img", {
                                            class: "avatar",
                                            src: (item === null || item === void 0 ? void 0 : item.avatar) || 'https://image.iguopin.com/data/app/im-logo.png',
                                            onerror: "this.src='https://image.iguopin.com/data/app/im-logo.png'"
                                        }, null, 8, _hoisted_17),
                                        (!_ctx.isH5)
                                            ? (vue_1.openBlock(), vue_1.createElementBlock("span", _hoisted_18, vue_1.toDisplayString(item.nick || item.userID), 1))
                                            : vue_1.createCommentVNode("", true)
                                    ], 64))
                                    : vue_1.renderSlot(_ctx.$slots, "right", {
                                        key: 1,
                                        data: item
                                    }, undefined, true)
                            ]),
                            (!_ctx.isH5)
                                ? (vue_1.openBlock(), vue_1.createElementBlock("i", {
                                    key: 0,
                                    class: "icon icon-cancel",
                                    onClick: function ($event) { return (_ctx.selected(item)); }
                                }, null, 8, _hoisted_19))
                                : vue_1.createCommentVNode("", true)
                        ]));
                    }), 128))
                ], 512), [
                    [vue_1.vShow, _ctx.resultShow]
                ]),
                vue_1.createElementVNode("footer", null, [
                    vue_1.createElementVNode("button", {
                        class: "btn btn-cancel",
                        onClick: _cache[3] || (_cache[3] =
                            //@ts-ignore
                            function () {
                                var args = [];
                                for (var _i = 0; _i < arguments.length; _i++) {
                                    args[_i] = arguments[_i];
                                }
                                return (_ctx.cancel && _ctx.cancel.apply(_ctx, args));
                            })
                    }, vue_1.toDisplayString(_ctx.$t("component.取消")), 1),
                    (_ctx.selectedList.length > 0)
                        ? (vue_1.openBlock(), vue_1.createElementBlock("button", {
                            key: 0,
                            class: "btn",
                            onClick: _cache[4] || (_cache[4] =
                                //@ts-ignore
                                function () {
                                    var args = [];
                                    for (var _i = 0; _i < arguments.length; _i++) {
                                        args[_i] = arguments[_i];
                                    }
                                    return (_ctx.submit && _ctx.submit.apply(_ctx, args));
                                })
                        }, vue_1.toDisplayString(_ctx.$t("component.完成")), 1))
                        : (vue_1.openBlock(), vue_1.createElementBlock("button", {
                            key: 1,
                            class: "btn btn-no",
                            onClick: _cache[5] || (_cache[5] =
                                //@ts-ignore
                                function () {
                                    var args = [];
                                    for (var _i = 0; _i < arguments.length; _i++) {
                                        args[_i] = arguments[_i];
                                    }
                                    return (_ctx.submit && _ctx.submit.apply(_ctx, args));
                                })
                        }, vue_1.toDisplayString(_ctx.$t("component.完成")), 1))
                ])
            ])
        ])
    ], 2));
}
exports.render = render;
